import { createAsyncTypes } from 'utils/ActionCreator'

export const COMPANY_FILTER_APPLY = 'PartnerOptions/COMPANY_FILTER_APPLY'
export const COMPANY_FILTER_CHANGE = 'PartnerOptions/COMPANY_FILTER_CHANGE'

export const FETCH_SELECTED_COMPANY_DATA_ASYNC = createAsyncTypes(
  'FETCH_SELECTED_COMPANY_DATA',
  'PartnerOptions'
)

export const NAME_FOR_HISTORY_STORE = 'PartnerOptions'
